import MultiEditNotification from './MultiEditNotification';

export default MultiEditNotification;
